// removed by extract-text-webpack-plugin
module.exports = {"headerContainer":"xFn2UXPF9Elkz0v4ItuTy","navElement":"_25LNjf_-mR5rQ0aOfE3RQ2","active":"_1d201kpGCNbQOiI7WYzd-b"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/css/header.css
// module id = 302
// module chunks = 0